import type { NodeRegistrationStatus, RegisteredNode } from '../../../apps/apis/commandCenter/types';

/** Pending first — the approval queue is why this panel exists; revoked sinks below the live fleet. */
const STATUS_RANK: Record<NodeRegistrationStatus, number> = { pending: 0, approved: 1, revoked: 2 };

export const sortForApproval = (nodes: RegisteredNode[]): RegisteredNode[] =>
  [...nodes].sort(
    (a, b) => STATUS_RANK[a.status] - STATUS_RANK[b.status] || Date.parse(b.lastSeen) - Date.parse(a.lastSeen),
  );

export const pendingCount = (nodes: RegisteredNode[]): number =>
  nodes.filter((node) => node.status === 'pending').length;
